export function validMail(email: string) {
  const regExp = /^[^\s()<>@,;:\\/]+@\w[\w.-]+\.[a-z]{2,}$/i;
  return regExp.test(email);
}

export function randomCode() {
  return Math.floor(100000 + Math.random() * 900000);
}
